<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex
      v-for = "(value, project) in projects"
      :key = 'project.key'
      >
      <v-card v-on:click='openProject(project)'>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex xs5>
              <div class='title' v-text='project'>
              </div>
          </v-flex>
      </v-layout>
      <v-layout row>
                  <v-flex>
            <v-card-media
            :src='projectImagesURLs[project]'
            height = '100px'
            contain
            >
          </v-card-media>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
    <v-container fluid>
    <v-layout row wrap>
      <v-flex xs5>
      <v-btn flat @click.native.stop='openProject(project)'> Open Project </v-btn>
    </v-flex>
<!--     <v-flex xs1 offset-xs6>
      <v-btn flat icon small round @click.native.stop='changeImage(project)'>
        <v-icon>photo</v-icon>
      </v-btn>
            <input type='file' id='pictureInput' style="display:none" @change='handleFiles(this.files)'/>
    </v-flex> -->
    </v-layout>
    </v-container>
    </v-card-actions>
  </v-card>
  </v-flex>
  </v-layout>
  </v-container>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex'
  import {firestore} from '@/firebase/firebase'
  export default {
    name: 'project-selector',
    data () {
      return {
        projectImagesURLs: {}
      }
    },
    computed: {
      ...mapGetters('project', {
        projects: 'projects'
      })
      // projects () {
      //   return this.$store.getters.project.projects
      // }
    },
    created: function () {
      // this.$store.dispatch('fetchProjects')
      this.fetchProjects()
    },
    mounted: function () {
      for (let project in this.projects) {
        let storageRef = firestore.ref('/' + project + '/logo.png')
        let that = this
        storageRef.getDownloadURL().then(function (url) {
          that.$set(that.projectImagesURLs, project, url)
        })
      }
    },
    methods: {
      ...mapActions('project', {
        fetchProjects: 'fetchProjects'
      }),
      openProject (projectName) {
        this.$router.push('/project/' + projectName)
      },
      handleFiles (files) {
        // console.log(files)
      },
      changeImage (projectName) {
        var fileElem = document.getElementById('pictureInput')
        fileElem.click()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/project/ProjectSelector.vue